import { createSelector } from '@reduxjs/toolkit';
import { selectAmenity } from 'shared/selectors/jsonQuery';
import { EAmenityType } from '../../../../packages/api-models/common/json_query';

export const AMENITY_LABELS: Record<EAmenityType, string> = {
  [EAmenityType.Wifi]: 'Wi-Fi',
  [EAmenityType.BikeParking]: 'Велопарковка',
  [EAmenityType.Internet]: 'Высокоскоростной интернет',
  [EAmenityType.RestZone]: 'Зоны отдыха',
  [EAmenityType.Cafe]: 'Кафе',
  [EAmenityType.Cleaning]: 'Клининг',
  [EAmenityType.Kitchen]: 'Кухня',
  [EAmenityType.Furniture]: 'Мебель',
  [EAmenityType.Security]: 'Охрана',
  [EAmenityType.Parking]: 'Парковка',
  [EAmenityType.MeetingRoom]: 'Переговорные комнаты',
  [EAmenityType.Printer]: 'Принтер и сканер',
  [EAmenityType.Reception]: 'Ресепшн',
  [EAmenityType.Modern]: 'Современный ремонт',
  [EAmenityType.Gym]: 'Спорт-зал',
  [EAmenityType.PhoneBooth]: 'Телефонные будки',
  [EAmenityType.TechSupport]: 'Техническая поддержка',
  [EAmenityType.Events]: 'Участие в мероприятиях',
  [EAmenityType.Fax]: 'Факс',
  [EAmenityType.Flipchart]: 'Флипчарт',
  [EAmenityType.Fruits]: 'Фрукты и закуски',
  [EAmenityType.Tea]: 'Чай/кофе',
  [EAmenityType.Lockers]: 'Шкафчики',
  [EAmenityType.LegalAddress]: 'Юридический адрес',
};

const OPTIONS = Object.entries(AMENITY_LABELS).map(([value, label]) => ({
  label,
  value: Number(value) as EAmenityType,
}));

export const selectAmenityFilter = createSelector(selectAmenity, value => ({
  label: 'Включено в стоимость',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
